import { Skeleton } from "primereact/skeleton";

import { C } from "sj-ui-toolkit/src/atlas/utils";

import S from "./_styles.module.scss";

export default function QuizSkeleton() {
  return (
    <div className={S.quizContainer}>
      <div className={S.quizBody}>
        <div className="flex flex-col gap-2">
          <Skeleton height="2rem" width="60%" />
          <Skeleton height="1.5rem" width="75%" />
        </div>

        <div className="flex flex-col gap-2.5">
          <Skeleton height="1.25rem" width="5rem" />
          <Skeleton height="1.5rem" width="100%" />
          <Skeleton height="1.25rem" width="7rem" />
          <div className="flex justify-between"></div>
        </div>

        {[...Array(3)].map((_, n) => (
          <div className={S.quizQuestion} key={n}>
            <fieldset className="flex flex-col gap-6">
              <legend className="mb-2">
                <Skeleton height="1.25rem" width="5rem" />
              </legend>
              <Skeleton height="1.5rem" width="90%" className="mb-2" />
              <div className="flex flex-col gap-3">
                {[...Array(4)].map((_, i) => (
                  <Skeleton key={i} height="1rem" width="50%" />
                ))}
              </div>
            </fieldset>
            <Skeleton height="1.25rem" width="9rem" />
          </div>
        ))}
      </div>

      <div className={C(S.quizFooter, "flex justify-end items-center")}>
        <Skeleton height="2.25rem" width="6rem" borderRadius="var(--radius-sm)" />
      </div>
    </div>
  );
}
